import { __, gt } from 'lodash/fp';

export const gtOne = gt(__, 1);
export const gtZero = gt(__, 0);
